import { IkeyCloakOptions } from "./types";
import { TenantType } from "types/generic/tenant";

export const getInitOptions = (tenant: TenantType): IkeyCloakOptions => {
    const initOptions: IkeyCloakOptions = {
        url: tenant.authUrl,
        realm: tenant.realm,
        clientId: tenant.clientId,
        onLoad: "login-required",
    };

    return initOptions;
};

